﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDriver = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateCompanies_1 = require("./StateCompanies");
const StateVehicles_1 = require("./StateVehicles");
const StateProfiles_1 = require("../profiles/StateProfiles");
const StateDrivers_1 = require("./StateDrivers");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateDriver extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDriver, "Driver", true);
        this._userId = 0;
        this._companyId = 0;
        this.page.ctrls.btnSelectUser.onclick = () => this._trySelectUser();
        this.page.ctrls.btnSelectCompany.onclick = () => this._trySelectCompany();
        this.page.ctrls.btnAddVehicle.onclick = () => this._tryAddVehicle();
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.DriverFull)
                    this._driver = args;
                else if (args.id) {
                    this._driver = yield this.lockgui(this.app.api.admin.directory.getDriver(args.id));
                    if (!this._driver)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._driver)
                this._urlArgs["id"] = this._driver.userShort.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var ctrl = this.page.ctrls;
            ctrl.btnDelete.show();
            if (this._driver) {
                yield ctrl.form.fillFormData(this._driver.driver, true);
                this._setDriver(this._driver.userShort);
                ctrl.btnSelectUser.hide();
                ctrl.listUsers.addClass('no-active');
                if (this._driver.company.id != 0)
                    this._setCompany(this._driver.company);
                this.page.ctrls.listVehicles.html = '';
                for (const vehicle of this._driver.linkedVehicles) {
                    yield this._addVehicle(vehicle);
                }
                if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.DriverControl)) {
                    ctrl.form.addClass('no-active');
                    ctrl.btnSelectCompany.hide();
                    ctrl.btnAddVehicle.hide();
                    ctrl.btnSave.hide();
                    ctrl.btnDelete.hide();
                }
            }
            else {
                ctrl.btnDelete.hide();
                ctrl.blockSelectCompany.hide();
                ctrl.blockSelectVehicles.hide();
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._driver)
                this.setLabel(this.title + ` #${this._driver.userShort.id} ${this._driver.userShort.name} ${this._driver.userShort.surname}`);
        });
    }
    _trySelectUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield StateProfiles_1.StateProfiles.SelectUser();
            if (!user)
                return;
            this._setDriver(user);
            yield gs_1.StateGS.RunInstance(this);
        });
    }
    _trySelectCompany() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._driver) {
                yield new modalCom.DialogOk("Need create and save driver before it").show();
            }
            const company = yield StateCompanies_1.StateCompanies.SelectCompany();
            if (!company)
                return;
            const result = yield this.lockgui(this.app.api.admin.directory.companySetUser(this._userId, company.id));
            if (!result)
                return;
            this._setCompany(company);
            yield gs_1.StateGS.RunInstance(this);
        });
    }
    _tryAddVehicle() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._driver) {
                yield new modalCom.DialogOk("Need create and save driver before it").show();
            }
            const vehicle = yield StateVehicles_1.StateVehicles.SelectVehicle();
            if (!vehicle)
                return;
            const result = yield this.lockgui(this.app.api.admin.directory.driverAddVehicle(this._userId, vehicle.id));
            if (result) {
                this._addVehicle(vehicle);
                yield gs_1.StateGS.Run(StateDriver, { id: this._userId });
            }
            else
                yield gs_1.StateGS.RunInstance(this);
        });
    }
    _setDriver(user) {
        this._userId = user.id;
        const item = new com.ListItem();
        item.ctrls.lType.text = "Profile";
        item.ctrls.lId.text = `#${user.id}`;
        let data = [gs.text.clearHtmlToText(`${user.name} ${user.surname}`)];
        item.ctrls.pData.html = data.join('<br>');
        this.page.ctrls.listUsers.html = '';
        this.page.ctrls.listUsers.append(item);
    }
    _setCompany(company) {
        return __awaiter(this, void 0, void 0, function* () {
            this._companyId = company.id;
            const item = new com.ListItem();
            item.ctrls.lType.text = "Company";
            item.ctrls.lId.text = `#${company.id}`;
            let data = [gs.text.clearHtmlToText(`${company.shortName}`)];
            item.ctrls.pData.html = data.join('<br>');
            this.page.ctrls.listCompanies.html = '';
            this.page.ctrls.listCompanies.append(item);
        });
    }
    _addVehicle(vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            const vt = yield this.app.astra.getVehiclesType(vehicle.vehicleTypeId);
            const item = new com.ListItem();
            item.addClass('vehicle' + vehicle.id);
            item.ctrls.lType.text = "Vehicle";
            item.ctrls.lId.text = `#${vehicle.id}`;
            let data = [gs.text.clearHtmlToText(`Type: ${vt.name}`),
                gs.text.clearHtmlToText(`Model: ${vehicle.model}`),
                gs.text.clearHtmlToText(`Gov.number: ${vehicle.govNumber}`),
            ];
            item.ctrls.pData.html = data.join('<br>');
            this.page.ctrls.listVehicles.append(item);
            item.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const answer = yield new modalCom.DialogOkNo("Unlink this vehicle from the driver?").show();
                if (answer != modalCom.ModalDialogResult.Ok)
                    return;
                const result = yield this.lockgui(this.app.api.admin.directory.driverRemoveVehicle(this._userId, vehicle.id));
                if (!result)
                    return;
                this.page.ctrls.listVehicles.q('.vehicle' + vehicle.id).cut();
            });
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            const req = new models_1.DriverRequest(data);
            let driver;
            if (this._driver) {
                req.userId = this._driver.userShort.id;
                driver = yield this.lockgui(this.app.api.admin.directory.updateDriver(req));
                if (!driver)
                    return;
                yield new modalCom.DialogOk("Driver updated").show();
            }
            else {
                const req = new models_1.DriverRequest(data);
                req.userId = this._userId;
                if (!req.userId) {
                    yield new modalCom.DialogOk("Need select profile of driver").show();
                    return;
                }
                driver = yield this.lockgui(this.app.api.admin.directory.createDriver(req));
                if (!driver)
                    return;
                yield new modalCom.DialogOk("Driver created").show();
                yield gs_1.StateGS.Run(StateDriver, { id: this._userId });
            }
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const responce = yield this.lockgui(this.app.api.admin.directory.deleteDriver(this._userId));
            if (!responce)
                return;
            yield new modalCom.DialogOk("Driver deleted").show();
            yield gs_1.StateGS.Run(StateDrivers_1.StateDrivers);
        });
    }
}
exports.StateDriver = StateDriver;
StateDriver.StateName = "driver";
//# sourceMappingURL=StateDriver.js.map